export class UserOtherFavoriteModel {
    userOtherFavoriteId?: any;
    title?: any;
    url?: any;
    isActive?: any;
    createBy?: any;
    createdTime?: any;
    modifiedBy?: any;
    modifiedTime?: any;
    userId?: any;
    totalRecordCount?: any;
}
